module.exports = __webpack_public_path__ + "static/media/lnpk.f6a68a5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/injectionMoulds/lnpk.jpg
// module id = 207
// module chunks = 0